import { API_ROOT } from '#src/config.ts';
import { useSnackNotificationContext } from '#src/contexts/snackNotification/index.ts';
import { client, clientWithoutCredentials } from '#src/lib/http.ts';

type PresignResponse = {
  url: string;
  fields: {
    key: string;
    policy: string;
    'x-amz-credential': string;
    'x-amz-algorithm': string;
    'x-amz-date': string;
    'x-amz-security-token': string;
    'x-amz-signature': string;
  };
};

export const useUploadWithPresign = () => {
  const { showNotification } = useSnackNotificationContext();

  return async (file: File): Promise<Nullable<string>> => {
    const url = new URL(`${API_ROOT}/presigns`);
    url.searchParams.set('filename', file.name);
    url.searchParams.set('content_type', file.type);
    const json = (await client.post(url.toString())).data as PresignResponse;

    const form = new FormData();
    const keys = Object.keys(json.fields) as (keyof typeof json.fields)[];
    keys.forEach(key => form.append(key, json.fields[key]));
    form.append('file', file);

    try {
      await clientWithoutCredentials.post(json.url, form);
    } catch {
      showNotification('uploadError');
      return null;
    }

    return json.fields.key;
  };
};
